module.exports = __webpack_public_path__ + "img/business.b4a8665a.svg";